import React from 'react';
export function UrgencyBar() {
  return <div className="bg-gold text-black py-2.5 px-4 text-center z-[60] relative font-bold text-xs tracking-wide uppercase" data-id="element-311">
      <span className="hidden sm:inline" data-id="element-312">
        ✨ Launch pricing available · 47% OFF
      </span>
      <span className="sm:hidden" data-id="element-313">✨ Launch pricing · 47% OFF</span>
    </div>;
}